import React, { memo, useMemo, useCallback } from 'react';
import classnames from 'classnames';
import Drawer from "../Drawer";
import "./index.scss";
const ShareDialog = ({
  visible,
  className,
  hasMask,
  onClose,
  onClick,
  opts,
  targets,
  title = '请选择分享方式',
  type = 'calendar'
}) => {
  const targetButtons = useMemo(() => options2Element('target', targets), [targets]);
  const optButtons = useMemo(() => options2Element('opt', opts), [opts]);
  const btnClick = useCallback(e => {
    const id = e.target.dataset.id || e.target.parentElement.dataset.id || e.target.parentElement.parentElement.dataset.id;
    onClick(id);
  }, [onClick]);
  return /*#__PURE__*/React.createElement(Drawer, {
    className: classnames('cc-share-dialog', className, {
      'activity-share-dialog': type === 'activity'
    }),
    visible: visible,
    onClose: onClose,
    title: null,
    hasMask: hasMask
  }, /*#__PURE__*/React.createElement("div", {
    className: "cc-share-title"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "cc-share-targets"
  }, targetButtons.map(b => /*#__PURE__*/React.createElement("div", {
    className: "cc-share-target",
    key: b.id,
    onClick: btnClick,
    "data-id": b.id
  }, /*#__PURE__*/React.createElement("div", {
    className: "icon"
  }, /*#__PURE__*/React.createElement("img", {
    src: b.icon
  })), /*#__PURE__*/React.createElement("div", {
    className: "name"
  }, b.name)))), type === 'activity' ? /*#__PURE__*/React.createElement("div", {
    className: "cancel-btn",
    onClick: onClose
  }, "\u53D6\u6D88") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "split"
  }), /*#__PURE__*/React.createElement("div", {
    className: "cc-share-targets opt"
  }, optButtons.map(b => /*#__PURE__*/React.createElement("div", {
    className: "cc-share-target",
    key: b.id,
    onClick: btnClick,
    "data-id": b.id
  }, /*#__PURE__*/React.createElement("div", {
    className: "icon"
  }, /*#__PURE__*/React.createElement("img", {
    src: b.icon
  })), /*#__PURE__*/React.createElement("div", null, b.name))))));
};
const options2Element = (t, opt) => {
  const buildIn = t === 'target' ? buildInTarget : buildInOpts;
  if (!opt) return buildIn;
  return opt.map(o => typeof o === 'string' ? buildIn[o] : o);
};
const buildInTarget = [{
  name: '微信',
  icon: 'https://cdn.calendar.tencent.com/calendar_res/wx.svg',
  id: 'wx'
}, {
  name: '朋友圈',
  icon: 'https://cdn.calendar.tencent.com/calendar_res/moments.svg',
  id: 'wx_moment'
}, {
  name: 'QQ',
  icon: 'https://cdn.calendar.tencent.com/calendar_res/qq.png',
  id: 'qq'
}, {
  name: '企业微信',
  icon: 'https://cdn.calendar.tencent.com/calendar_res/wx_work.svg',
  id: 'wework'
}];
const buildInOpts = [{
  name: '复制链接',
  icon: 'https://cdn.calendar.tencent.com/calendar_res/copy.svg',
  id: 'copy'
}, {
  name: '保存图片',
  icon: 'https://cdn.calendar.tencent.com/calendar_res/saveimg.svg',
  id: 'savePic'
}];
ShareDialog.displayName = 'cc-sharedialog';
export default /*#__PURE__*/memo(ShareDialog);